import React from 'react'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { projects } from '../../assets/data/projectsData'

const SeeProjects = () => {
  return (
    <div className='projects-content'>
      <div>
        <h1>Projects</h1>
        <div className='work-list'>
          {projects.map((project) => {
            const { id, name, description, url, img } = project
            return (
              <div key={id} className='work'>
                <img src={img} alt='' />
                <div className='layer'>
                  <h3>{name}</h3>
                  <p>{description}</p>
                  <a className='ex-link' href={url} target='_blank'>
                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                  </a>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default SeeProjects
